import { initMainPage } from '../pages/index/main.js'
import { initMissionPage } from '../pages/mission/mission.js'
import { initContactsPage } from '../pages/contacts/contacts.js'
import { initPolicyPage } from '../pages/policy/policy.js'
import { initItActivityPage } from '../pages/it-activity/it-activity.js'
import { initBlogPage } from '../pages/blog/blog.js'
import { initBlogArticlePage } from '../pages/blog-article/blog-article.js'
import { init404Page } from '../pages/404/404.js'
import '../yandex_metrika.js'

import { Cases } from "../components/widgets/cases-section/cases";
import { Faq } from "../components/widgets/faq-section/faq";

// Глобальные компоненты — инициализируем один раз при загрузке приложения
import { TryModalClass } from '../components/widgets/try-modal/try-modal';
import { ContactFormClass } from "../components/widgets/contacts-section/contacts";
import { CookieBannerClass } from '../components/widgets/cookie-banner/cookie-banner';

import * as Turbo from '@hotwired/turbo'
Turbo.start()

document.addEventListener('turbo:load', initializeComponents);

function initializeComponents() {
  const pathname = window.location.pathname;
  const tryModal = new TryModalClass();
  // const contactForm = new ContactFormClass();
  new CookieBannerClass();

  if (pathname === '/' || pathname === '/index') {
    // Initialize main page components
    initMainPage();
  } else if (pathname === '/mission') {
    // Initialize mission page components
    initMissionPage();
  } else if (pathname === '/contacts') {
    // Initialize contacts page components
    initContactsPage();
  } else if (pathname === '/policy') {
    // Initialize policy page components
    initPolicyPage();
  } else if (pathname === '/it-activity') {
    // Initialize IT activity page components
    initItActivityPage();
  } else if (pathname === '/articles') {
    // Initialize blog page components
    initBlogPage();
  } else if (pathname.startsWith('/articles/')) {
    // Initialize blog article page components
    initBlogArticlePage();
  } else {
    // Initialize 404 page components
    init404Page();
  }
  // Автоматическая инициализация компонентов по data-атрибутам
  document.querySelectorAll('[data-component]').forEach(element => {
    const componentName = element.dataset.component;
    switch(componentName) {
      case 'cases':
        Cases.init();
        break;
      case 'faq':
        Faq.init();
        break;
      // Другие компоненты
    }
  });
}

//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'
